import {gql} from '@apollo/client'

export const CREATE_VENTAS = gql`
  mutation saleCreate($input: SaleCreateInput!) {
    saleCreate(input: $input) {
      success
      errors {
        field
        message
      }
      sale {
        id
      }
    }
  }
`
export const EDITAR_VENTA = gql`
  mutation saleUpdate($input: SaleUpdateInput!) {
    saleUpdate(input: $input) {
      errors {
        field
        message
      }
      success
    }
  }
`
export const ANULAR_VENTA = gql`
  mutation cancelSale($input: CancelSaleInput!) {
    cancelSale(input: $input) {
      errors {
        field
        message
      }
      success
    }
  }
`
